// API から StreamableFile + Content-Disposition: attachment で返されるレスポンスを
// axios の responseType: 'blob' で受けて、ブラウザにダウンロードダイアログを出す DOM helper。
//
// 典型形(store action):
//   api.get<Blob>(url, { responseType: 'blob' }).then(({ data }) => triggerBlobDownload(data, filename))
//
// document.body への append/remove は一部ブラウザで click() が反応しないケースを避けるため。
// FileSaver.js 等の外部ライブラリは不要 — createObjectURL → anchor.click → revokeObjectURL で完結する。
export function triggerBlobDownload(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
  URL.revokeObjectURL(url)
}
